import { useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router';

const HELP_LINT_URL =
    'https://support.bigleaf.net/hc/en-us/articles/26545597191707-Getting-Started-with-the-Bigleaf-Web-Dashboard';

export const Description = () => {
    const { t } = useTranslation();

    return (
        <>
            {/* it's 784px by design, but this value is needed to match design look */}
            <div className="w-full xl:w-[785px] text-center mb-6">
                <p>
                    <Trans
                        i18nKey={`welcome_dialog:main:p1:content`}
                        components={{
                            span: <span className="font-semibold" />,
                        }}
                        values={{
                            highlighted: t(
                                'welcome_dialog:main:p1:highlighted'
                            ),
                        }}
                    />
                </p>
                <p>
                    <Trans
                        i18nKey={`welcome_dialog:main:p2:content`}
                        components={{
                            span: <span className="font-semibold" />,
                        }}
                        values={{
                            highlighted: t(
                                'welcome_dialog:main:p2:highlighted'
                            ),
                        }}
                    />
                </p>
            </div>

            <p className="text-center">
                {t('welcome_dialog:main:get_started:text')}
                <br className="xl:hidden" />{' '}
                <Link to={HELP_LINT_URL} className="text-primary-700 underline">
                    {t('welcome_dialog:main:get_started:link_text')}
                </Link>
            </p>

            <p className="text-center mt-4">
                {t('welcome_dialog:main:WDB_v1_toggle:text')}
            </p>
        </>
    );
};
